import type { RelationshipType } from '@apparatix/schemas/Relationship';
import type { Activity, ActivityReminder } from '@apparatix/schemas/Activities';
import { AsKeyed } from '@apparatix/types';

export enum ActivityFields {
  None = 0,
  Date = 1 << 0,
  Files = 1 << 1,
  Note = 1 << 2,
  Purpose = 1 << 3,
  Relationships = 1 << 4,
  Reminder = 1 << 5,
  Title = 1 << 6,
  Method = 1 << 7,
  Delete = 1 << 8,
  ReminderType = 1 << 9,
}

export type ModalAction =
  | 'create-activity'
  | 'update-activity'
  | 'create-note'
  | 'update-note'
  | 'create-reminder'
  | 'update-reminder';

export type ActivityItemProps = {
  activity: Activity;
  parentType?: RelationshipType;
  parentId?: number;
  showAllRelationships?: boolean;
  isInFlyout?: boolean;
  relationshipButtonsKeepParent?: boolean;
}

export type ActivitySection = {
  label: string;
  badgeSeverity: 'danger' | 'primary' | 'success';
  items: Array<AsKeyed<Activity>>;
}

export type ActivityAddedEvent = (activity: Activity, shouldReloadActivities: boolean) => void;
export type ActivityDeletedEvent = (id: number) => void;
export type ActivityUpdatedEvent = (activity: Activity, shouldReloadActivities: boolean) => void;
export type ReminderItem = ActivityReminder & { activity: Activity };

export const hasFlag = (test: ActivityFields, flags: ActivityFields) => (test & flags) !== 0;
